module.exports = __webpack_public_path__ + "img/separator15.73400b33.svg";